import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-edit-leads',
  templateUrl: './edit-leads.component.html',
  styleUrls: ['./edit-leads.component.css']
})
export class EditLeadsComponent implements OnInit {

  constructor(private leadService:ServiceService) { }

  LeadId=""
  output:any=[];
  //getUrl='http://192.241.151.66:5000/viewContact/';
  data={
    first_name:"",
    last_name:"",
    email:"",
    contact_1:"",
    contact_2:""
  }
  isShown=false
  alert=""
 
  email:any=new FormControl('', [Validators.required, Validators.email]);
  mobile:any=new FormControl('', [Validators.required, Validators.pattern("[0-9]{10}$")]);
  NameAlert=""
  MobileAlert=""
  EmailAlert=""

   //--------function for shown the alert----------
 shown(){
  this.isShown=false
}

//---------check value changes in the name text box----
valuechange1(newValue1: any) {
  this.data.first_name=newValue1
  this.NameAlert=""
  }
  //---------check value changes in the text box----
 valuechange2(newValue1: any) {
  this.data.contact_1=newValue1
  this.MobileAlert=""
}
//---------check value changes in the text box----
valuechange3(newValue1: any) {
  this.data.email=newValue1
  this.EmailAlert=""
}

//--------function for submit edited changes-----
Submit(){
  /*
  if(this.read==true)
  {
    return;
  }
  if(this.data.first_name=="")
    {
      this.NameAlert="enter a name "
      return;
    }
    if(this.data.contact_1!="" && this.mobile.invalid)
    {
     this.MobileAlert="enter a mobile number"
     return;
    }
    if (this.email.invalid && this.data.email != "")
    {
      this.EmailAlert="invalid email id"
      return;
    }
    if(this.data.first_name!="" && this.mobile.valid && this.email.valid)
    {
      this.isShown=true
     
    }
  */
}

  ngOnInit(): void {

     //---call function in service for lead Id------
     this.LeadId=this.leadService.getLeadId();
    //-------api get()calling-------------
    this.leadService.ViewContact(this.LeadId).subscribe((res)=>{
    this.output=res.data
    console.log("details=",this.output)
    this.data.first_name=this.output[0].first_name;
    this.data.last_name=this.output[0].last_name;
    this.data.email=this.output[0].email;
    this.data.contact_1=this.output[0].contact_1;
    this.data.contact_2=this.output[0].contact_2;
  })

  }

}
